import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { TodoPlanner } from './components/todoPlanner/TodoPlanner';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import AlertsContainer from './components/alertsContainer/AlertsContainer';
import * as serviceWorker from './serviceWorker';

/* eslint-disable */
if (document.getElementById('todoPlanner')) {
  ReactDOM.render(<TodoPlanner />,
    document.getElementById('todoPlanner'));
}

if (document.getElementById('scrollToTop-CCL')) {
  ReactDOM.render(<ScrollToTop />,
    document.getElementById('scrollToTop-CCL'));
}

if (document.getElementById('CCL_alertContainer_react')) {
  ReactDOM.render(<AlertsContainer />,
    document.getElementById('CCL_alertContainer_react'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./reactComponents/index.js